import mustache from "mustache";
import { CompraAnimalesResponse } from "../../../../../modulos/pesaje/ganaderia/response/CompraAnimalesResponse";
import { daysBetween, formatFechaCorta } from "../../../../../utils/fechaUtils";
import { _2d, _miles } from "../../../../../utils/numberUtils";
import { IConnectRender } from "../../../../definitions/IConnectRender";
import { LoteInfoGanaderiaRender } from "../../../terceros/lote/loteInfo/LoteInfoGanaderiaRender";
import template from "./compraDetailTemplate.html";

mustache.parse(template);

/** Detalle de solo lectura de una compra, con los mismos campos y secciones que
 *  el formulario (estilo `summary-item`). Sin listeners. */
export class CompraDetailRender implements IConnectRender {
  constructor(private readonly _compra: CompraAnimalesResponse) {}

  render(): string {
    const c = this._compra;
    const fechaCompra = c.fechaCompra;
    const costoTotal = c.precioTotal;
    const costoPorAnimal =
      c.cantidadAnimalesCompra > 0 ? costoTotal / c.cantidadAnimalesCompra : 0;
    const ganancia = c.pesoTargetSalida - c.pesoPromedioEntrada;
    // Fecha esperada de salida y días en finca: desde el valor del server.
    const dias = c.fechaEsperadaSalida
      ? daysBetween(c.fechaCompra, c.fechaEsperadaSalida)
      : 0;
    const fechaVenta = c.fechaEsperadaSalida
      ? formatFechaCorta(c.fechaEsperadaSalida)
      : "—";

    const loteEntrada = new LoteInfoGanaderiaRender(c.loteEntrada);
    const loteActual = new LoteInfoGanaderiaRender(c.loteActual);

    return mustache.render(template, {
      fecha: fechaCompra ? formatFechaCorta(fechaCompra) : "—",
      tipo: c.tipoAnimal,
      raza: c.razaAnimal,
      cantidad: c.cantidadAnimalesCompra,
      pesoPromedio: `${_2d(c.pesoPromedioEntrada)} kg`,
      precioKg: `$ ${_miles(c.precioKg)}`,
      pesoTotal: `${_miles(c.pesoTotal)} kg`,
      costoTotal: `$ ${_miles(costoTotal)}`,
      costoPorAnimal: `$ ${_miles(costoPorAnimal)}`,
      loteEntrada: loteEntrada.render(),
      loteActual: loteActual.render(),
      gdp: `${c.gdpEsperadoGr} g/día`,
      pesoTarget: `${_2d(c.pesoTargetSalida)} kg`,
      ganancia: ganancia > 0 ? `${_2d(ganancia)} kg` : "—",
      diasEstimados: dias > 0 ? `${dias} días` : "—",
      fechaVenta: fechaVenta,
    });
  }

  connect(): void {}

  dispose(): void {}
}
